__webpack_require__.p = "https://media-assets.swiggy.com/swiggy-one-subscription/_next/";